// Only suppress standalone absence notices, never warnings about check dates,
// PVN deadlines, unreadable text, contradictions, or multiple issues in one warning.
const isMissingValidityDateWarning = (warning) => {
  const text = String(warning).trim().replace(/[.!]$/, '').replace(/[-_]/g, ' ').replace(/\s+/g, ' ');
  const qualifier = '(?:(?:specific|clear|explicit|exact) )?';
  const validity = '(?:valid from(?: (?:or|and) valid until)?|valid until|expiry|expiration|validity|validity start|validity end|start(?: (?:or|and) end)?|end)';
  const subject = `(?:${qualifier}${validity} dates?|${qualifier}dates? for (?:right to work|permission) validity)`;
  return new RegExp(`^(?:no|missing|absent) ${subject}(?: (?:present|provided|specified|stated|found|available)(?: in (?:the )?document)?)?$`, 'i').test(text)
    || new RegExp(`^${subject} (?:is |are )?(?:missing|absent|not (?:provided|specified|stated|found|available))(?: in (?:the )?document)?$`, 'i').test(text);
};

export { isMissingValidityDateWarning };
